import { Link, Stack, Typography } from '@mui/material'
import { ToastContentProps } from 'react-toastify'

import * as OrderTexts from '../../../../intl'

type CustomNotificationProps = ToastContentProps<{
  formattedDate: string
  onClick: () => void
}>

export function CustomNotification({ data }: CustomNotificationProps) {
  if (!data) {
    return null
  }

  const { formattedDate, onClick } = data

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="body2" sx={theme => ({ color: theme.vars.palette.common.white })}>
        {OrderTexts.orderMovedOutsideOpenedDayToastMessage(formattedDate)}
      </Typography>
      <Link
        onClick={onClick}
        sx={theme => ({
          flexShrink: 0,
          whiteSpace: 'nowrap',
          marginX: 2,
          cursor: 'pointer',
          color: theme.vars.palette.common.white,
          textDecoration: 'underline',
          textDecorationColor: theme.vars.palette.common.white,
        })}
      >
        {OrderTexts.navigateToOrderLabel()}
      </Link>
    </Stack>
  )
}
